package streetlight.web.ui

import koala.SvgFile
import koala.modifier.*
import koala.dom.*
import kampfire.model.tapOf
import koala.html.spacer
import streetlight.web.layouts.ThemeColor
import streetlight.web.model.LocationScout

fun ViewScope.locationFinder(model: LocationScout) = formCard("Location Finder") {
    setStyle(Css.ColorScheme.of(ThemeColor.Location.cssValue))

    formRow {
        formSection("search") {
            row {
                textField(model.queryField, "search", Flex1)
                textField(model.cityField, "city", Width(24))
            }
            selectorContainer {
                selectorBlock(items = model.locationsState, selection = model.selectionState) { location ->
                    searchItem(location.name, location.address, location.city)
                }
                flowBlock(model.queryField.tapOf { it.isEmpty() }) { isQueryEmpty ->
                    when (isQueryEmpty) {
                        true -> centeredText("Start typing in the search box to see locations")
                        false -> column(AlignItemsCenter) {
                            centeredText("Don't see the location in the list? Try a power search with OpenStreetMap.")
                            formSubmit("Search OSM", model::queryOSM, model.queryMessage, Primary)
                        }
                    }
                }
            }
        }
    }

    formSection("or just put it on the map") {
        geoMapMount(mod = FormMod.GeoMap)
        row(AlignItemsStart) {
            button("What is Here?", model::whatIsHere)
            spacer(Flex1)
            messageBox(model.mapMessage)
            textField(model.queryField)
            button("Create", onClick = model::createLocation, Accent)
        }
    }
}

private fun ViewScope.searchItem(
    name: String?,
    address: String?,
    city: String?,
) = row(AlignItemsCenter) {
    icon(SvgFile.MapPinLarge, modify(Height(5), ColorSchemeFg))
    column(modify(Flex1, Gap0)) {
        textBlock(name ?: "a location", Bold)
        spacer(modify(Height2Px, InkGradientBg))
        address?.let {
            textBlock(it)
        }
    }
    city?.let {
        icon(SvgFile.City, modify(Height(3), ColorSchemeFg))
        textBlock(it, modify(OpacityHigh, Width(16)))
    }
}